import React from 'react';
import './ProjectSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';

const ProjectSingle = () => { 

  // Get project details passed via router state
  const location = useLocation();  
  const projectSingle = location.state; 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Project Single'} page={'Project Single'} />

      <section className='project-single page-single'>

        <div className='project-info page-info'>

          {/* Project Image Section */}
          <div className='image'>
            <img src={projectSingle.image} alt={projectSingle.title} />
          </div>

          <div className='content'>

            {/* Project Title */}
            <h3 className='main-heading'>{projectSingle.title}</h3>

            {/* Project Description */}
            {projectSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Project Image Gallery */}
            <Lightbox images={projectSingle.gallery} />

            {/* Project Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Challenges:</h3>

              {/* Introduction to challenges */}
              <p>{projectSingle.challenges.intro}</p>
              
              {/* List of project challenges */}
              <ul>
                {projectSingle.challenges.points.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* Project Solutions Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Solutions:</h3>

              {/* Introduction to solutions */}
              <p>{projectSingle.solutions.intro}</p>

              {/* List of solutions */}
              <ul>
                {projectSingle.solutions.points.map((solution, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* Project Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Result:</h3>

              {/* Introduction to results */}
              <p>{projectSingle.results.intro}</p>
              
              {/* List of achieved results */}
              <ul>
                {projectSingle.results.points.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div> 
        
        </div> 

        {/* Sidebar with project details */}
        <PageSidebar
          heading={'Project'}
          details={projectSingle.details}
        />

      </section>

    </> 
  );
}

export default ProjectSingle;